module.exports = __webpack_public_path__ + "static/media/hybrid-reality.0a2ec802.jpg";